import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { GraduationCap, School, BookOpen, Users, ShieldCheck, CalendarRange, ArrowRight } from "lucide-react";

const StatCard = ({ icon: Icon, label, value, tid }) => (
  <Card className="rounded-2xl border-none shadow-[0_8px_30px_rgb(16,42,86,0.06)] p-5 bg-white" data-testid={tid}>
    <div className="w-11 h-11 rounded-2xl bg-gradient-to-br from-gtsorange to-gtsorange-light flex items-center justify-center mb-3">
      <Icon className="w-5 h-5 text-white" />
    </div>
    <p className="text-3xl font-nunito font-extrabold text-gtsnavy leading-none">{value}</p>
    <p className="text-sm text-muted-foreground mt-1">{label}</p>
  </Card>
);

export default function TeacherHome() {
  const { user } = useAuth();
  const [d, setD] = useState(null);

  useEffect(() => { api.get("/teacher/dashboard").then((r) => setD(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-6" data-testid="teacher-home">
      <div className="rounded-3xl bg-gradient-to-br from-gtsorange to-gtsorange-light text-white p-7 shadow-xl">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-2xl bg-white/20 flex items-center justify-center">
            <GraduationCap className="w-7 h-7" />
          </div>
          <div>
            <p className="text-sm text-white/80">English Extracurricular Program – IEC Mustikajaya</p>
            <h1 className="font-nunito font-extrabold text-2xl md:text-3xl" data-testid="teacher-welcome">
              Welcome, {user?.name}
            </h1>
          </div>
        </div>
        {d && (
          <div className="mt-4 flex flex-wrap gap-2 text-sm">
            <span className="rounded-full bg-white/15 px-3 py-1 flex items-center gap-1.5">
              <CalendarRange className="w-4 h-4" /> Tahun Pelajaran {d.active_year || "-"}
            </span>
            <span className="rounded-full bg-white/15 px-3 py-1">Semester {d.active_semester}</span>
          </div>
        )}
      </div>

      {user?.must_change_password && (
        <div className="rounded-2xl bg-amber-50 border border-amber-200 p-4 flex items-start gap-3" data-testid="change-password-suggestion">
          <ShieldCheck className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="text-sm font-semibold text-amber-800">Amankan akun Anda</p>
            <p className="text-sm text-amber-700">Sebaiknya ganti password awal Anda melalui halaman Profil.</p>
          </div>
          <Link to="/profile"><Button size="sm" className="rounded-full bg-amber-500 hover:bg-amber-600 text-white" data-testid="go-profile-btn">Ganti Password</Button></Link>
        </div>
      )}

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard icon={School} label="Sekolah Ditugaskan" value={d?.schools_count ?? "–"} tid="stat-schools" />
        <StatCard icon={BookOpen} label="Kelas Saya" value={d?.classes_count ?? "–"} tid="stat-classes" />
        <StatCard icon={Users} label="Siswa Aktif" value={d?.students_count ?? "–"} tid="stat-students" />
        <StatCard icon={GraduationCap} label="Rapor Selesai" value={d?.finished_reports ?? 0} tid="stat-reports" />
      </div>

      <Card className="rounded-2xl border-none shadow-[0_8px_30px_rgb(16,42,86,0.06)] p-6 bg-white">
        <h2 className="font-nunito font-bold text-gtsnavy text-lg mb-1">Aksi Cepat</h2>
        <p className="text-sm text-muted-foreground mb-4">Kelola kelas dan daftar siswa Anda.</p>
        <div className="flex flex-wrap gap-3">
          <Link to="/classes"><Button className="rounded-full bg-gtsnavy text-white gap-2" data-testid="quick-manage-classes"><BookOpen className="w-4 h-4" /> Kelola Kelas Saya <ArrowRight className="w-4 h-4" /></Button></Link>
          <Link to="/profile"><Button variant="outline" className="rounded-full gap-2" data-testid="quick-profile"><ShieldCheck className="w-4 h-4" /> Profil & Password</Button></Link>
        </div>
        <p className="text-xs text-muted-foreground mt-4">Input Nilai, Rekap Kelas, dan Student Progress Report akan aktif pada tahap berikutnya.</p>
      </Card>
    </div>
  );
}
